import { Grid, Typography, List, ListItemButton } from "@mui/material";
import { Header } from "gf-ui-components-mui-lib";
import { Contact, Logout, DownOrgArr, DropOrgIcon } from "@/icons";
import { Skeleton } from "@/apps/core/elements/Skeleton";
import { useAuth } from "@/hooks/auth.hooks";
import { SIDEBAR_WIDTH } from "@/layouts/full/sidebar";
// import { getCookie } from "@/utils";

const HeaderLayout = ({ isDropdownOpen, dropdownItems, handleDropdownSelect }: any) => {
  //const loginDomainName = getCookie("xsm_user_domain");
  const { handleLogout, loggedUser, hasSingleProduct } = useAuth();

  const controls_data = [
    {
      id: "theme",
      label: "Theme",
      icon: <Skeleton style={{ width: "24px", height: "24px" }} />
    },
    {
      id: "notification",
      label: "Notification",
      icon: <Skeleton style={{ width: "24px", height: "24px" }} />
    }
  ];

  const menuitems = [
    {
      id: "logout",
      label: hasSingleProduct ? "Logout" : "Exit",
      icon: <Logout />,
      handleItem: () =>
        handleLogout({ redirectToLogoutEndpoint: hasSingleProduct })
    }
  ];

  return (
    <Header
      {...{
        position: "fixed",
        color: "inherit",
        searchBar: false,
        controls: controls_data,
        user: loggedUser?.first_name ?? "",
        menuItems: menuitems,
        createDomain: false,
        xsmadmin: true,
        adminIcon: <Contact />,
        chipChild: (
          <Grid>
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                // gap: '8px',
                padding: "8px",
                borderRadius: "10px",
                border: "1px solid var(--Gray-300, #E6E6E6)",
                cursor: "pointer",
                width: "236px",
                justifyContent: "space-between"
              }}
            >
              <Grid
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                <DropOrgIcon fill="#242424" />
                <Typography
                  sx={{
                    color: "black",
                    fontSize: "16px",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px"
                  }}
                >
                  {"Select Organization"}
                </Typography>
              </Grid>
              <DownOrgArr fill="#737373" />
            </Grid>
            <Grid
              sx={{
                position: "relative"
              }}
            >
              {isDropdownOpen && (
                <Grid
                  className="select-org-dropdown"
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "0px",
                    display: "flex",
                    padding: "16px 0px",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "8px",
                    borderRadius: "16px",
                    background: "#FFF",
                    boxShadow:
                      "0px -4px 8px 0px rgba(0, 0, 0, 0.05), 0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
                    zIndex: 999,
                    width: "236px"
                  }}
                >
                  <List
                    component="nav"
                    sx={{
                      padding: "0px !important",
                      width: "100%"
                    }}
                  >
                    {dropdownItems?.map((item: any) => {
                      return (
                        <ListItemButton
                          key={item.id}
                          style={{
                            padding: "8px 16px",
                            display: "flex",
                            alignItems: "center",
                            color: "#0A1629",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "24px"
                          }}
                          onClick={() => handleDropdownSelect(item)}
                        >
                          {item.name}
                        </ListItemButton>
                      );
                    })}
                  </List>
                </Grid>
              )}
            </Grid>
          </Grid>
        ),
        sx: {
          boxShadow: "none",
          zIndex: "10",
          height: "86px",
          justifyContent: "center",
          marginLeft: `${SIDEBAR_WIDTH}px`,
          width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
          padding: "0px 32px",
          "& .MuiToolbar-root": {
            padding: "0px !important"
          },
          "& .MuiIconButton-edgeEnd": {
            paddingRight: "16px"
          },
          '& button[aria-controls="primary-search-account-menu"] > svg:last-of-type': {
            display: "none"
          }
        }
      }}
    />
  );
};

export default HeaderLayout;
